const config = {
  vuexStorageKeys: [
    'sessionToken'
  ],
  plugins: [
    'tk',
    'device',
    'vuexStorage',
    'user',
    'index',
    'routerAuth'
  ],
  navTheme: 'light', // 导航主题: dark 或 light
  layoutMode: 'sidemenu', // 布局类型：sidemenu 或 topmenu
  contentWidth: 'Fluid', // 内容布局类型，Fluid 或 Fixed
  fixedHeader: true, // 是否固定头部
  fixSidebar: true, // 是否固定左侧导航栏
  projectName: '优邻云享管理后台',
  // apiUrl: 'http://192.168.50.223:3333',
  apiUrl: 'https://cloud.runji.mokekeji.com',
  // apiUrl: 'https://cloud.runji.mokekeji.com',
  appID: '1',
  masterKey: '1',
  restKey: '',
  modelJSON: require('./assets/json/model'),
  iconJSON: require('./assets/json/icon')
}
export default config
